export var AudioUnitType;
(function (AudioUnitType) {
    AudioUnitType["Instrument"] = "instrument";
    AudioUnitType["Bus"] = "bus";
    AudioUnitType["Aux"] = "aux";
    AudioUnitType["Output"] = "output";
})(AudioUnitType || (AudioUnitType = {}));
